import(/* webpackMode: "eager" */ "/vercel/path0/packages/halo-query/app/global-error.tsx");
